export const GET_LOG_REPORT_CONFIG_LIST = 'GET_LOG_REPORT_CONFIG_LIST';
export const SET_LOG_REPORT_CONFIG_LIST = 'SET_LOG_REPORT_CONFIG_LIST';
export const DELETE_LOG_REPORT_CONFIG = 'DELETE_LOG_REPORT_CONFIG';
export const SAVE_LOG_REPORT_CONFIG = 'SAVE_LOG_REPORT_CONFIG';
